// Regions: the areas that scope rates, managers and providers.
const regions = {
  title: 'Regions',
  steps: () => [
    {
      target: null,
      title: 'Regions',
      body: 'A region is a named area (a metro, a state, a route). Rates can differ by region, a regional manager sees only their regions, and each provider site belongs to one.'
    },
    {
      target: 'regions-add',
      title: 'Create a region',
      body: 'Give it a name, the states or counties it covers, and the manager responsible. You can edit or remove it later from its row.',
      placement: 'left'
    },
    {
      target: 'regions-list',
      title: 'Your regions',
      body: 'Each row shows the region, its coverage and who manages it. Edit with the pencil; a region with sites or users attached cannot be deleted until they are moved.',
      placement: 'top'
    },
    {
      target: null,
      title: 'Where regions are used',
      body: 'Settings → Rate Management (rates per region), Settings → Sites (each site\'s region), Settings → Users (a regional manager\'s regions) and the Performance filters.'
    }
  ]
};

export default regions;
